var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "40",
      "height": "33",
      "viewBox": "0 0 40 33",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M1 26.498h38.1M36.703 26.498a16.973 16.973 0 10-33.292 0",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.05 6.216a2.608 2.608 0 100-5.216 2.608 2.608 0 000 5.216zM36.613 26.498l-1.692 4.427A1.673 1.673 0 0133.36 32H6.794a1.673 1.673 0 01-1.565-1.075l-1.69-4.427",
      "stroke": "#F1D5AA",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }